{
  "source": {
    "brand": "realizations/shared/shared-brand.json",
    "visualIdentity": "registries/visual-identity/visual-identity.json"
  },
  "primary": {
    "900": "#1e3a5f",
    "800": "#1e40af",
    "700": "#2563eb",
    "600": "#3b5fe0",
    "500": "#3b82f6",
    "300": "#93c5fd",
    "100": "#dbeafe"
  },
  "modes": {
    "immune": {
      "primary": "#06b6d4",
      "dim": "#0891b2",
      "label": "IMMUNE"
    },
    "inert": {
      "primary": "#a78bfa",
      "dim": "#7c3aed",
      "label": "INERT"
    },
    "contained": {
      "primary": "#ea580c",
      "dim": "#c2410c",
      "label": "CONTAINED"
    }
  },
  "generators": {
    "G1": {
      "primary": "#f97316",
      "label": "Authority"
    },
    "G2": {
      "primary": "#6366f1",
      "label": "Knowledge"
    },
    "G3": {
      "primary": "#2dd4bf",
      "label": "Time"
    },
    "G4": {
      "primary": "#ee7733",
      "label": "Resource"
    }
  },
  "semantic": {
    "amber": "#f59e0b",
    "blue": "#3b82f6",
    "blueStrong": "#2563eb",
    "cyan": "#22d3ee",
    "cyanStrong": "#0891b2",
    "danger": "#ef4444",
    "dangerStrong": "#dc2626",
    "dangerSoft": "#f87171",
    "emerald": "#34d399",
    "emeraldStrong": "#10b981",
    "fuchsia": "#e879f9",
    "gold": "#fbbf24",
    "indigo": "#818cf8",
    "indigoStrong": "#6366f1",
    "lime": "#65a30d",
    "magenta": "#f472b6",
    "mint": "#2dd4bf",
    "mutedBlue": "#6b7a8d",
    "mutedCool": "#7a8aa6",
    "mutedSteel": "#7080a0",
    "orange": "#fb923c",
    "orangeStrong": "#f97316",
    "pink": "#ec4899",
    "purple": "#c084fc",
    "purpleStrong": "#a855f7",
    "rose": "#fb7185",
    "sky": "#38bdf8",
    "skySoft": "#60a5fa",
    "skyStrong": "#0ea5e9",
    "slate": "#94a3b8",
    "slateDark": "#475569",
    "slateDarker": "#334155",
    "success": "#22c55e",
    "teal": "#14b8a6",
    "tealSoft": "#5eead4",
    "violet": "#a78bfa",
    "violetStrong": "#7c3aed"
  },
  "theorems": {
    "SEPARATE": {
      "code": "S",
      "color": "#38bdf8",
      "bg": "rgba(56,189,248,0.10)",
      "mode": "IMMUNE"
    },
    "PERMIT": {
      "code": "P",
      "color": "#22d3ee",
      "bg": "rgba(34,211,238,0.10)",
      "mode": "IMMUNE"
    },
    "DATA.ORIGIN": {
      "code": "D1",
      "color": "#6366f1",
      "bg": "rgba(99,102,241,0.10)",
      "mode": "IMMUNE"
    },
    "DATA.REACH": {
      "code": "D2",
      "color": "#a78bfa",
      "bg": "rgba(167,139,250,0.10)",
      "mode": "IMMUNE"
    },
    "PRECOMMIT": {
      "code": "W",
      "color": "#2dd4bf",
      "bg": "rgba(45,212,191,0.10)",
      "mode": "IMMUNE"
    },
    "RES.CONSUME": {
      "code": "R1",
      "color": "#f97316",
      "bg": "rgba(249,115,22,0.10)",
      "mode": "CONTAINED"
    },
    "RES.RELEASE": {
      "code": "R2",
      "color": "#ee7733",
      "bg": "rgba(238,119,51,0.10)",
      "mode": "CONTAINED"
    },
    "COMPOSE": {
      "code": "C",
      "color": "#cc6677",
      "bg": "rgba(204,102,119,0.10)",
      "mode": "INERT"
    },
    "INV.ESTABLISH": {
      "code": "I1",
      "color": "#eab308",
      "bg": "rgba(234,179,8,0.10)",
      "mode": "INERT"
    },
    "INV.PRESERVE": {
      "code": "I2",
      "color": "#f59e0b",
      "bg": "rgba(245,158,11,0.10)",
      "mode": "INERT"
    }
  },
  "dualPairs": {
    "DATA.LINEAGE": {
      "code": "D1+D2",
      "color": "#10b981",
      "bg": "rgba(16,185,129,0.10)",
      "mode": "immune"
    },
    "RES.BALANCE": {
      "code": "R1+R2",
      "color": "#84cc16",
      "bg": "rgba(132,204,22,0.10)",
      "mode": "contained"
    },
    "INV.CONSISTENCY": {
      "code": "I1+I2",
      "color": "#4ade80",
      "bg": "rgba(74,222,128,0.10)",
      "mode": "inert"
    }
  },
  "compositionalityPrinciples": {
    "TRACE": {
      "code": "Tr",
      "color": "#e879f9",
      "bg": "rgba(232,121,249,0.10)",
      "level": 1
    },
    "ALWAYS": {
      "code": "Al",
      "color": "#d946ef",
      "bg": "rgba(217,70,239,0.10)",
      "level": 1
    },
    "ACCOUNT": {
      "code": "St",
      "color": "#c026d3",
      "bg": "rgba(192,38,211,0.10)",
      "level": 1
    },
    "REQUIRE": {
      "code": "At",
      "color": "#f472b6",
      "bg": "rgba(244,114,182,0.10)",
      "level": 2
    },
    "DELEGATE": {
      "code": "Dt",
      "color": "#ec4899",
      "bg": "rgba(236,72,153,0.10)",
      "level": 2
    },
    "DECOMPOSE": {
      "code": "De",
      "color": "#db2777",
      "bg": "rgba(219,39,119,0.10)",
      "level": 2
    },
    "PARTITION": {
      "code": "Pa",
      "color": "#be185d",
      "bg": "rgba(190,24,93,0.10)",
      "level": 2
    }
  },
  "safe": {
    "700": "#059669",
    "500": "#34d399",
    "300": "#6ee7b7",
    "100": "#d1fae5"
  },
  "warn": {
    "700": "#dc2626",
    "500": "#f87171",
    "300": "#fca5a5",
    "100": "#fee2e2"
  },
  "gray": {
    "900": "#1e293b",
    "700": "#334155",
    "600": "#64748b",
    "500": "#94a3b8",
    "400": "#cbd5e1",
    "300": "#e2e8f0",
    "100": "#f8fafc",
    "50": "#ffffff"
  },
  "font": {
    "display": "'Fraunces', Georgia, serif",
    "heading": "'DM Sans', system-ui, sans-serif",
    "body": "'DM Sans', system-ui, sans-serif",
    "mono": "'JetBrains Mono', 'Fira Code', ui-monospace, monospace",
    "mono-math": "'JuliaMono', 'JetBrains Mono', ui-monospace, monospace",
    "math": "'STIX Two Math', 'Latin Modern Math', 'Cambria Math', serif",
    "serif": "'STIX Two Text', Georgia, serif",
    "hyperlegible": "'Atkinson Hyperlegible', 'DM Sans', system-ui, sans-serif",
    "interface": "'IBM Plex Sans', 'DM Sans', system-ui, sans-serif"
  }
}
